import { ThemeSize } from '@/types/styles/ThemeSize'
import { createContext, Dispatch, SetStateAction } from 'react'

export const ChosenThemeSizeActionContext = createContext<Dispatch<SetStateAction<ThemeSize | undefined>>>(() => {});

export default ChosenThemeSizeActionContext;